module.exports = __webpack_public_path__ + "static/media/Illus-SupplyChain@3x.e05a83c8.png";